import React, {Component} from "react";
import {connect} from "react-redux";
import {monthFilterStyle} from "../../../services/utils";
import ReactSelect, {components} from "react-select";
import {
  setEventStatsEndMonth, setEventStatsStartOptions, setMonthMenus
} from "../../../actions/actions/eventStats";


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} />
    </components.DropdownIndicator>
  );
};

class EndMonthFilter extends Component {

  handleSelectChange = (value) => {
    this.props.setEventStatsEndMonth(value);
  }

  openMenu = () => {
    this.props.setMonthMenus({startMonthMenuOpen: false, endMonthMenuOpen: !this.props.eventStatsFilter.endMonthMenuOpen});
  }

  render() {

    return (
      <div onClick={() => this.openMenu()}>
        <ReactSelect
          className="my-2 mx-4 event-small-filter"
          onChange={this.handleSelectChange}
          value={{value: this.props.eventStatsFilter.endMonth, label: this.props.eventStatsFilter.endMonthLabel}}
          styles={monthFilterStyle()}
          defaultValue={{ value: this.props.eventStatsFilter.endMonth, label: this.props.eventStatsFilter.endMonthLabel }}
          options={this.props.eventStatsFilter.endOptions}
          components={{ DropdownIndicator, IndicatorSeparator:() => null, Input:() => null}}
          menuIsOpen={this.props.eventStatsFilter.endMonthMenuOpen}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  setEventStatsEndMonth,
  setEventStatsStartOptions,
  setMonthMenus,
};

export default connect(mapStateToProps, mapDispatchToProps)(EndMonthFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/EndMonthFilter.js